import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TruncatedText from "../../components/TruncatedText";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import EuroIcon from "@material-ui/icons/EuroSymbol";
import Paper from "@material-ui/core/Paper";

import {
  Event as ScheduleIcon,
  PictureAsPdf as PdfIcon,
  GridOn as ExcelIcon,
  Mail as MailIcon,
  RemoveCircleRounded as PersonRemoveIcon,
  AddBoxRounded as PersonAddIcon,
  Delete as DeleteIcon,
  Archive as ArchiveIcon,
  RestoreFromTrash as RestoreIcon,
  PhoneAndroid as PhoneIcon,
  Block as BlockIcon,
  RemoveCircleOutline as RemoveCircleIcon,
  Report,
  Block,
  AttachMoney as PaidIcon,
  Visibility as ViewIcon,
  Person as PersonIcon,
} from "@material-ui/icons";
import "./style.css";
import SelectInput from "../SelectInput";
import PageTitle from "../../components/PageTitle/PageTitle";
import DataNascitaInput from "../DataNascitaInput";

function descendingComparator(a, b, orderBy) {
  // Verifica se stiamo ordinando per una colonna di date
  if (orderBy === "created_at") {
    // Formattazione per data nel formato DD/MM/YYYY HH:mm
    const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;

    // Estrai le componenti della data
    const aMatches = a[orderBy] ? a[orderBy].match(dateRegex) : null;
    const bMatches = b[orderBy] ? b[orderBy].match(dateRegex) : null;

    if (aMatches && bMatches) {
      // Converti in formato YYYY-MM-DD HH:mm per un confronto corretto
      const aDate = new Date(
        `${aMatches[3]}-${aMatches[2]}-${aMatches[1]}T${aMatches[4]}:${aMatches[5]}`
      );
      const bDate = new Date(
        `${bMatches[3]}-${bMatches[2]}-${bMatches[1]}T${bMatches[4]}:${bMatches[5]}`
      );

      // Confronta le date (ordine discendente)
      if (bDate < aDate) {
        return -1;
      }
      if (bDate > aDate) {
        return 1;
      }
      return 0;
    }
  } else if (
    orderBy === "data" ||
    orderBy === "data_creazione" ||
    orderBy === "data_consegna"
  ) {
    // Gestisce date delle dispense e compiti che possono avere o non avere l'ora
    const parseDateString = (dateStr) => {
      if (!dateStr) return new Date(0); // Data minima per valori vuoti

      // Regex per DD/MM/YYYY HH:mm
      const dateTimeRegex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
      // Regex per DD/MM/YYYY
      const dateOnlyRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;

      const dateTimeMatches = dateStr.match(dateTimeRegex);
      const dateOnlyMatches = dateStr.match(dateOnlyRegex);

      if (dateTimeMatches) {
        // Con ora: DD/MM/YYYY HH:mm
        return new Date(
          `${dateTimeMatches[3]}-${dateTimeMatches[2]}-${dateTimeMatches[1]}T${dateTimeMatches[4]}:${dateTimeMatches[5]}`
        );
      } else if (dateOnlyMatches) {
        // Solo data: DD/MM/YYYY
        return new Date(
          `${dateOnlyMatches[3]}-${dateOnlyMatches[2]}-${dateOnlyMatches[1]}T00:00:00`
        );
      }

      return new Date(0); // Fallback
    };

    const aDate = parseDateString(a[orderBy]);
    const bDate = parseDateString(b[orderBy]);

    // Confronta le date (ordine discendente)
    if (bDate < aDate) {
      return -1;
    }
    if (bDate > aDate) {
      return 1;
    }
    return 0;
  }

  // Per gli altri campi, usa la logica originale
  if (typeof b[orderBy] === "number") {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
  } else {
    const bValue = b[orderBy] ? b[orderBy].toLowerCase() : "";
    const aValue = a[orderBy] ? a[orderBy].toLowerCase() : "";

    if (bValue < aValue) {
      return -1;
    }
    if (bValue > aValue) {
      return 1;
    }
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = props.headCells;

  return (
    <TableHead>
      <TableRow>
        <TableCell></TableCell>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            //align={headCell.numeric ? 'right' : 'left'}
            align={props.noCerca ? "center" : "left"}
            padding={false ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{
              fontWeight: "bold",
              width: headCell.id === "__" ? "20px" : "auto",
            }}
          >
            {headCell.label !== "" && headCell.id !== "_" ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : (
              <span style={{ fontWeight: "bold" }}>{headCell.label}</span>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    ></Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // Rimuove l'effetto hover e rende sempre visibili le frecce di ordinamento
    "& .MuiTableSortLabel-icon": {
      opacity: "1 !important",
    },
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

//create your forceUpdate hook
function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

export default function EnhancedTable(props) {
  const classes = useStyles();

  // Recupera lo stato salvato dal localStorage se disponibile
  const getStorageKey = (suffix) => {
    return props.storageKey ? `${props.storageKey}_${suffix}` : null;
  };

  const getSavedState = (key, defaultValue) => {
    if (!props.storageKey) return defaultValue;
    try {
      const saved = localStorage.getItem(getStorageKey(key));
      return saved !== null ? JSON.parse(saved) : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  };

  const [order, setOrder] = React.useState(
    getSavedState("order", props.desc ? "desc" : "asc")
  );
  const [orderBy, setOrderBy] = React.useState(
    getSavedState("orderBy", props.orderBy || props.headCells[0].id)
  );
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(getSavedState("page", 0));
  const [dense, setDense] = React.useState(false);
  const [searchText, setSearchText] = React.useState(
    getSavedState("searchText", "")
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  // Salva lo stato nel localStorage quando cambia
  useEffect(() => {
    if (props.storageKey) {
      localStorage.setItem(getStorageKey("order"), JSON.stringify(order));
    }
  }, [order, props.storageKey]);

  useEffect(() => {
    if (props.storageKey) {
      localStorage.setItem(getStorageKey("orderBy"), JSON.stringify(orderBy));
    }
  }, [orderBy, props.storageKey]);

  useEffect(() => {
    if (props.storageKey) {
      localStorage.setItem(getStorageKey("page"), JSON.stringify(page));
    }
  }, [page, props.storageKey]);

  useEffect(() => {
    if (props.storageKey) {
      localStorage.setItem(
        getStorageKey("searchText"),
        JSON.stringify(searchText)
      );
    }
  }, [searchText, props.storageKey]);

  // Mantenere l'ordinamento coerente tra le pagine
  useEffect(() => {
    if (props.orderBy) {
      setOrderBy(props.orderBy);
    }
    if (props.defaultOrder) {
      setOrder(props.defaultOrder);
    }
  }, [props.orderBy, props.defaultOrder]);

  var rows = props.rows || [];

  if (searchText !== "") {
    rows = [];
    props.rows.forEach((r) => {
      var found = false;
      var lowerSearch = searchText.toLowerCase();

      props.searchCols.forEach((element) => {
        const fieldValue = r[element];
        if (
          fieldValue &&
          fieldValue
            .toString()
            .toLowerCase()
            .indexOf(lowerSearch) !== -1
        ) {
          found = true;
        }
      });

      if (found === true) rows.push(r);
    });
  }

  const forceUpdate = useForceUpdate();

  const handleRequestSort = (event, property) => {
    let newOrder = "asc";

    // Se è la stessa colonna, alterna tra asc e desc
    if (orderBy === property) {
      newOrder = order === "asc" ? "desc" : "asc";
    }

    // Aggiorna immediatamente entrambi gli stati
    setOrder(newOrder);
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.eventName);
      //   setSelected(newSelecteds);
      return;
    }
    //   setSelected([]);
  };

  const handleChange = (e) => {
    setSearchText(e.target.value);
    forceUpdate();
  };

  const resetSearch = () => {
    if (searchRef.current !== null) {
      searchRef.current.value = "";
      setSearchText("");
    }
    forceUpdate();
  };

  const handleClick = (id, name) => {
    if (props.onEventClick) props.onEventClick(id);

    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    //   setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  var searchRef = React.createRef();

  function isHTML(str) {
    const pattern = /<("[^"]*"|'[^']*'|[^'">])*>/;
    return pattern.test(str);
  }

  return (
    <div className={classes.root}>
      {!props.noCerca && (
        <div style={{ marginBottom: 10, display: "inline-flex" }}>
          <span style={{ fontFamily: "Glacial Indifference" }}> Cerca:</span>

          <input
            ref={searchRef}
            value={searchText}
            style={{ marginLeft: 10 }}
            type="text"
            onChange={(e) => {
              handleChange(e);
            }}
          ></input>
          <div
            style={{ marginLeft: 10, cursor: "pointer" }}
            onClick={resetSearch}
          >
            X
          </div>
        </div>
      )}

      {props.filterTags && !props.removeTags && (
        <div
          style={{ marginBottom: 10, display: "flex", alignItems: "center" }}
        >
          <div>
            <SelectInput
              value={props.selectedTags}
              name="Tag"
              hidable={false}
              options={props.filterTags}
              isMulti={true}
              onChange={props.handleTagChange}
            />
          </div>
        </div>
      )}

      {props.filterTags && props.removeTags && (
        <div
          style={{ marginBottom: 10, display: "flex", alignItems: "center" }}
        >
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <SelectInput
              value={props.selectedTags}
              name="Tag"
              hidable={false}
              options={props.filterTags}
              isMulti={true}
              onChange={props.handleTagChange}
            />
            <SelectInput
              value={props.excludedTags}
              name="Escludi Tag"
              hidable={false}
              options={props.filterTags}
              isMulti={true}
              onChange={props.handleTagRemoveChange}
            />

            <DataNascitaInput
              name={"Data inizio"}
              value={props.dataInizio}
              onChange={props.onChangeDataInizio}
            />
            <DataNascitaInput
              name={"Data fine"}
              value={props.dataFine}
              onChange={props.onChangeDataFine}
            />
            <div style={{ marginLeft: "auto" }}>
              <PageTitle
                button="RESET"
                onClick={() => {
                  if (props.onResetFilters) {
                    props.onResetFilters();
                  } else {
                    props.handleTagChange([]);
                    props.handleTagRemoveChange([]);
                    props.onChangeDataInizio("");
                    props.onChangeDataFine("");
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}

      {props.filterChiamati && (
        <div
          style={{ marginBottom: 10, display: "flex", alignItems: "center" }}
        >
          <div>
            <SelectInput
              value={props.prossimoAnno}
              name=""
              hidable={false}
              options={props.filterChiamati}
              isMulti={false}
              onChange={props.handleProssimoAnno}
            />
          </div>
        </div>
      )}

      {props.categorie && (
        <div
          style={{ marginBottom: 10, display: "flex", alignItems: "center" }}
        >
          <div>
            <SelectInput
              value={props.selectedCategoria}
              name="Categoria"
              hidable={false}
              options={props.categorie}
              isMulti={false}
              onChange={props.onChangeCategoria}
            />
          </div>

          {props.corsiAssociati && (
            <div style={{ marginLeft: 10 }}>
              <SelectInput
                value={props.selectedCorsi}
                name="Corsi"
                hidable={false}
                options={props.corsiAssociati}
                isMulti={false}
                onChange={props.onChangeCorsi}
              />
            </div>
          )}
        </div>
      )}

      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              headCells={props.headCells}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.eventName);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  const bgColor =
                    row.read === 0 || row.visto === 0 || row.visto === "0"
                      ? "rgba(204, 51, 51, 0.3)"
                      : props.type !== undefined &&
                        props.type === "billing" &&
                        (row.corsi_ritiro.includes(props.currentCourse + ";") ||
                          row.disabled === "1")
                      ? "#E7A9A2"
                      : index % 2 === 0
                      ? "#ffffff"
                      : "#f5f5f5";

                  const clickable = props.onEventClick
                    ? { cursor: "pointer" }
                    : {};

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      style={{ backgroundColor: bgColor, ...clickable }}
                      onClick={(event) => {
                        // Verifica se il click è direttamente sulla riga e non su un elemento figlio che ha un proprio gestore di eventi
                        if (
                          event.currentTarget === event.target &&
                          props.onEventClick
                        ) {
                          props.onEventClick(row.id);
                        }
                      }}
                    >
                      <TableCell padding="checkbox">
                        {/* <CheckBox elementId={row.id} onElementCheck={props.onElementCheck}/> */}
                      </TableCell>

                      {props.headCells.map((elem, indexColonna) => {
                        return (
                          <TableCell
                            onClick={(event) => {
                              if (!props.onCellClick) {
                                handleClick(row.id);
                              }
                            }}
                            align={props.noCerca ? "center" : "left"}
                            style={{
                              margin: "0",
                              padding: "0",
                              height: "0px",
                            }}
                            sx={{
                              height: "0px !important",
                            }}
                            key={elem.id}
                          >
                            {elem.id === "frequentanti" && (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                }}
                              >
                                <span
                                  key={index}
                                  style={{
                                    margin: "0 5px",
                                    paddingLeft: "30px",
                                    borderRadius: "3px",
                                  }}
                                >
                                  {row.frequentanti}
                                </span>
                              </div>
                            )}
                            {elem.id === "tag_name" ||
                            elem.id === "origine" ||
                            elem.id === "corso" ||
                            elem.id === "info_date" ? (
                              <div
                                style={{ display: "flex", flexWrap: "wrap" }}
                              >
                                {elem.id === "origine" ? (
                                  row.origine &&
                                  row.origine.split(",").map((tag, index) => (
                                    <span
                                      key={index}
                                      style={{
                                        margin: "0 5px",
                                        padding: "2px 5px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        backgroundColor: "#f0f0f0",
                                      }}
                                    >
                                      {tag.trim()}{" "}
                                    </span>
                                  ))
                                ) : elem.id === "corso" ? (
                                  row.corso &&
                                  row.corso.split(",").map((tag, index) => (
                                    <span
                                      key={index}
                                      style={{
                                        margin: "0 5px",
                                        padding: "2px 5px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        backgroundColor: "#f0f0f0",
                                      }}
                                    >
                                      {tag.trim()}{" "}
                                    </span>
                                  ))
                                ) : elem.id === "info_date" ? (
                                  row.info_date && (
                                    <span
                                      style={{
                                        margin: "0 5px",
                                        padding: "2px 5px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        backgroundColor: "#f0f0f0",
                                      }}
                                    >
                                      {row.info_date}
                                    </span>
                                  )
                                ) : row.tag_name || row.tag ? (
                                  (row.tag_name ? row.tag_name : row.tag)
                                    .split(",")
                                    .map((tag, index) => (
                                      <span
                                        key={index}
                                        style={{
                                          margin: "0 5px",
                                          padding: "2px 5px",
                                          border: "1px solid #ccc",
                                          borderRadius: "3px",
                                          backgroundColor: "#f0f0f0",
                                        }}
                                      >
                                        {tag.trim()}{" "}
                                      </span>
                                    ))
                                ) : (
                                  <span>Nessun Tag</span>
                                )}
                              </div>
                            ) : (
                              elem.id !== "frequentanti" && (
                                <div
                                  onClick={
                                    props.onCellClick
                                      ? () => {
                                          props.onCellClick(row.id, elem.id);
                                        }
                                      : null
                                  }
                                  style={{
                                    margin: "0",
                                    padding: "0",
                                  }}
                                >
                                  {/* Gestione speciale per voti unificati */}
                                  {props.votiUnificati &&
                                  elem.id !== "nome" &&
                                  elem.id !== "cognome" &&
                                  elem.id !== "id_studente" ? (
                                    (() => {
                                      const votoInfo = row.voti
                                        ? row.voti[elem.id]
                                        : null;

                                      if (!votoInfo) {
                                        return <span>-</span>;
                                      }

                                      const {
                                        valore,
                                        colore,
                                        recupero,
                                      } = votoInfo;

                                      // Determina il colore di sfondo e del testo
                                      let backgroundColor = "transparent";
                                      let color = "inherit";

                                      if (colore === "verde") {
                                        backgroundColor = "#d4edda"; // Verde chiaro
                                        color = "#155724";
                                      } else if (
                                        colore === "rosso" ||
                                        (recupero &&
                                          valore !== null &&
                                          valore !== "")
                                      ) {
                                        backgroundColor = "#f8d7da"; // Rosso chiaro
                                        color = "#721c24";
                                      }

                                      const cellStyle = {
                                        backgroundColor,
                                        color,
                                        padding: "6px 12px",
                                        borderRadius: "4px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        minWidth: "60px",
                                      };

                                      return (
                                        <div style={cellStyle}>
                                          <span>
                                            {valore !== null &&
                                            valore !== "" &&
                                            valore !== -1
                                              ? valore
                                              : "-"}
                                          </span>
                                          {recupero && valore === null && (
                                            <span
                                              style={{
                                                fontSize: "11px",
                                                color: "#666",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              (da recuperare)
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })()
                                  ) : elem.id === "descrizione" ? (
                                    <TruncatedText
                                      text={row[elem.id]}
                                      maxLength={100}
                                      maxLines={2}
                                    />
                                  ) : isHTML(row[elem.id]) ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: row[elem.id],
                                      }}
                                    />
                                  ) : (
                                    row[elem.id]
                                  )}
                                </div>
                              )
                            )}
                          </TableCell>
                        );
                      })}

                      {(props.onDelete ||
                        props.calendar ||
                        props.invoices ||
                        props.pdf ||
                        props.email ||
                        props.phone ||
                        props.blacklist ||
                        props.addPerson ||
                        props.removePerson ||
                        props.onBilling ||
                        props.onViewFile) && (
                        <TableCell
                          align="right"
                          className="iconsColumn"
                          style={{
                            display: "flex",
                            cursor: "pointer",
                            gap: "5px",
                          }}
                        >
                          {props.calendar !== undefined &&
                            props.calendar === true && (
                              <ScheduleIcon
                                className="icon"
                                titleAccess="Calendario"
                                style={{
                                  marginRight: 20,
                                  height: "25px",
                                  width: "25px",
                                }}
                                onClick={() => {
                                  props.onCalendarClick(row.id);
                                  //                          window.location.href= '#/app/schedule';
                                }}
                              />
                            )}
                          {props.invoices && (
                            <EuroIcon
                              className="icon"
                              titleAccess="Pagamenti"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() => props.onInvoicesPressed(row.id)}
                            />
                          )}

                          {props.blackList &&
                            (props.blackList.includes(row.id) ? (
                              <RemoveCircleIcon
                                className="icon"
                                titleAccess="Rimuovi dalla blacklist"
                                style={{
                                  height: "25px",
                                  width: "25px",
                                  color: "red",
                                }}
                                onClick={() => props.onBlacklistPressed(row.id)}
                              />
                            ) : (
                              <BlockIcon
                                className="icon"
                                titleAccess="Aggiungi alla blacklist"
                                style={{ height: "25px", width: "25px" }}
                                onClick={() => props.onBlacklistPressed(row.id)}
                              />
                            ))}

                          {props.pdf !== undefined && props.pdf === true && (
                            <PdfIcon
                              className="icon"
                              titleAccess="PDF"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() => {
                                props.onPdfClicked &&
                                  props.onPdfClicked(row.id);
                              }}
                            />
                          )}

                          {props.mail !== undefined && props.mail === true && (
                            <MailIcon
                              className="icon"
                              titleAccess="Email"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() =>
                                props.onSendMail && props.onSendMail(row.id)
                              }
                            />
                          )}
                          {props.phone !== undefined &&
                            props.phone === true && (
                              <PhoneIcon
                                className="icon"
                                titleAccess="Telefono"
                                style={{ height: "25px", width: "25px" }}
                                onClick={() =>
                                  props.onSendNotification &&
                                  props.onSendNotification(row.id)
                                }
                              />
                            )}

                          {props.onViewFile && row.nome_file && (
                            <ViewIcon
                              className="icon"
                              titleAccess="Visualizza file"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() => {
                                props.onViewFile(
                                  row.id,
                                  row.nome_file,
                                  props.fileType
                                );
                              }}
                            />
                          )}

                          {props.onDelete && props.corsi ? (
                            <ArchiveIcon
                              className="icon"
                              titleAccess="Archivia"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() => props.onDelete(row.id)}
                            />
                          ) : (
                            props.onDelete && (
                              <DeleteIcon
                                className="icon"
                                titleAccess="Elimina"
                                style={{ height: "25px", width: "25px" }}
                                onClick={() => props.onDelete(row.id)}
                              />
                            )
                          )}
                          {props.onRestore && (
                            <RestoreIcon
                              className="icon"
                              titleAccess="Ripristina"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() => props.onRestore(row.id)}
                            />
                          )}
                          {/* Pulsante assenze commentato su richiesta
                          {props.assenze && (
                            <Report
                              className="icon"
                              titleAccess="Assenze"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() => props.onAssenze(row.id)}
                            />
                          )}
                          */}
                          {props.students !== undefined &&
                            props.students &&
                            props.addPerson &&
                            !row.corsi_ritiro.includes(
                              props.currentCourse + ";"
                            ) && (
                              <PersonRemoveIcon
                                className="icon"
                                titleAccess="Rimuovi studente"
                                style={{ height: "25px", width: "25px" }}
                                onClick={() =>
                                  props.onRemoveStudent &&
                                  props.onRemoveStudent(row.id)
                                }
                              />
                            )}
                          {props.students !== undefined &&
                            props.students &&
                            props.addPerson &&
                            !row.corsi_ritiro.includes(
                              props.currentCourse + ";"
                            ) && (
                              <PersonIcon
                                className="icon"
                                titleAccess="Vai all'anagrafica studente"
                                style={{ height: "25px", width: "25px" }}
                                onClick={() =>
                                  props.onEditStudent &&
                                  props.onEditStudent(row.id)
                                }
                              />
                            )}
                          {props.students !== undefined &&
                            props.students &&
                            props.removePerson &&
                            row.corsi_ritiro.includes(
                              props.currentCourse + ";"
                            ) && (
                              <PersonAddIcon
                                className="icon"
                                titleAccess="Aggiungi studente"
                                style={{ height: "25px", width: "25px" }}
                                onClick={() =>
                                  props.onAddStudent &&
                                  props.onAddStudent(row.id)
                                }
                              />
                            )}
                          {props.withBilling && (
                            <PaidIcon
                              className="icon"
                              titleAccess="Pagamenti"
                              style={{ height: "25px", width: "25px" }}
                              onClick={() => props.onBilling(row.id)}
                            />
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[25]}
          component="div"
          count={rows.length}
          rowsPerPage={25}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
